import * as React from 'react';
import { Select, TextInput } from "soprasteria-ui-library";
import { IReferral } from '../../../models/IReferral';
import { formatAddress } from '../../../helpers/AddressHelper';
import { useAuth } from '../../../App';
import { IListItem } from 'soprasteria-ui-library/dist/models/IFormInput';
import { CarePerformerApi } from '../../../api/CarePerformerApi';
import { setMessage } from '../../../helpers/MessageHelper';
import { AlertMessage, AlertType } from "soprasteria-ui-library";

interface IReferralReferrerInformation {
    referral?: IReferral;
    setDefaultValue: (value?: string) => string;
}

export const ReferralReferrerInformation: React.FunctionComponent<IReferralReferrerInformation> = ({ referral, setDefaultValue }) => {

    const auth = useAuth();
    const carePerformerApi = new CarePerformerApi(auth);
    const [carePerformers, setCarePerformers] = React.useState<IListItem[]>([]);
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [errorMessage, setErrorMessage] = React.useState<string>();

    React.useEffect(() => {
        if (referral?.isEditable) {
            loadCarePerformerDentists();
        }

    }, [referral]);

    const loadCarePerformerDentists = () => {
        setIsLoading(true);
        carePerformerApi.getCarePerformerDentistsToday((carePerformers) => {
            let mappedCarePerformers = carePerformers.map<IListItem>((carePerformer) => { return { text: carePerformer.carePerformerName, value: carePerformer.carePerformerId.toString() } });
            if (mappedCarePerformers.length === 0) {
                const newMessage = setMessage("Det finns ingen registrerad behandlare för mottagningen. Ansök om ny behandlare, alternativt om behandlaren är registrerad på annan mottagning, lägg till behandlaren på mottagningen.", errorMessage ?? "");
                setErrorMessage(newMessage);
            } else {
                setErrorMessage("");
                setCarePerformers(mappedCarePerformers);
            }
        }, undefined, () => setIsLoading(false));
    }

    return (
        <>
            <AlertMessage alertType={AlertType.danger} duration={10000}>{errorMessage}</AlertMessage>
            <div className="row readonly-less-margin">
                <h5 className="col-12">Remitterande behandlare</h5>
                <div className="col-6">
                    {
                        referral === undefined || referral.isEditable ?
                        <>
                            <Select name="referrerCarePerformerId"
                                label="Namn"
                                placeholder="Välj en behandlare"
                                options={carePerformers}
                                isLoading={isLoading}
                                selectedValue={referral?.referrerCarePerformer?.carePerformerId.toString()}
                                inlineLabel
                                required={(referral?.isEditable ?? false)} />
                        </>
                            : <TextInput name="referrerCarePerformerReadonly" label="Namn" defaultValue={referral.referrerCarePerformer ? referral.referrerCarePerformer.carePerformerName : referral.referrerName} inlineLabel readonly />
                    }
                </div>
                <div className="col-6">
                    <TextInput name="emailReadonly" label="E-post" defaultValue={referral?.referrer?.address?.emailAddress ?? "Saknas"} inlineLabel readonly />
                </div>
                <div className="col-6">
                    <TextInput name="umbrellaReadonly" label="Vårdgivare" defaultValue={referral?.referrer?.displayOrganisationInformation} inlineLabel readonly />
                </div>
                <div className="col-6">
                    <TextInput name="phoneNumberReadonly" label="Telefon" defaultValue={referral?.referrer?.address?.phoneNumber ?? "Saknas"} inlineLabel readonly />
                </div>
                <div className="col-6">
                    <TextInput name="careproviderReadonly" label="Mottagning" defaultValue={referral?.referrer?.displayCareProviderName} inlineLabel readonly />
                </div>
                <div className="col-6">
                    <TextInput name="AltPhoneNumberReadonly" label="Alt. telefonnummer" defaultValue={referral?.referrer?.address?.alternativePhoneNumber ?? "Saknas"} inlineLabel readonly />
                </div>
                <div className="col-6">
                    <TextInput name="adress" label="Mottagningens adress" defaultValue={formatAddress(referral?.referrer?.address)} inlineLabel readonly />
                </div>
                <div className="col-6">
                    <TextInput name="externalIdFromReferrer" label="Remittents remiss-ID" defaultValue={setDefaultValue(referral?.externalIdFromReferrer)} inlineLabel readonly={!referral?.isEditable} />
                </div>
            </div>
        </>
    )
}